export default [
  {
    title: "Languages",
    icon: "",
    href: process.env.VUE_APP_ROOT_API + "/admin/ocom_project/language",
  },
  {
    title: "Frameworks",
    icon: "",
    href: process.env.VUE_APP_ROOT_API + "/admin/ocom_project/framework",
  },
  {
    title: "Databases",
    icon: "",
    href: process.env.VUE_APP_ROOT_API + "/admin/ocom_project/database",
  },
  {
    title: "Login Type",
    icon: "",
    href: process.env.VUE_APP_ROOT_API + "/admin/ocom_project/code_login_type",
  },
];
